import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

const MobileCard = styled.div`
  margin-bottom: 30px;
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 39px 0 rgba(0, 0, 0, 0.03);
  text-align: center;

  & + & {
    margin-bottom: 50px;
  }
`;

const MobileHeader = styled.div`
  border-radius: 3px 3px 0 0;
  background-color: #e5f2ff;
  padding: 20px 0;
  width: 330px;
  max-width: calc(100vw - 20px);
`;

const MobileFooter = styled.div`
  border-top: 1px solid #f1f1f1;
  padding: 20px 0;
  width: 330px;
  max-width: calc(100vw - 20px);
`;

const MobilePlan = styled.p`
  color: #686868;
  font-size: 15px;
  line-height: 17px;
  margin-bottom: 16px;
`;

const MobilePrice = styled.p`
  color: #686868;
  font-size: 15px;
  line-height: 17px;
  margin-bottom: 0;
  font-weight: bold;
`;

const MobileUl = styled.ul`
  padding: 30px 0 28px 0;
  width: 330px;
  max-width: calc(100vw - 20px);
`;

const MobileLi = styled.li`
  color: #686868;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 25px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const Button = styled.button`
  border: none;
  outline: none;
  border-radius: 3px;
  font-size: 14px;
  line-height: 16px;
  padding: 11px 42px;
  cursor: pointer;
  border: 1px solid #0079ff;
  color: #0079ff;
  background-color: #fff;

  &.active {
    color: #fff;
    background-color: #0079ff;
  }
`;

const TableBlock = () => {
  return (
    <React.Fragment>
      <MobileCard>
        <MobileHeader>
          <MobilePlan>Lite</MobilePlan>
          <MobilePrice>
            <FormattedMessage
              id="shop.table.price.first"
              defaultMessage="от 999 лей/месяц"
            />
          </MobilePrice>
        </MobileHeader>
        <MobileUl>
          <MobileLi>
            <FormattedMessage
              id="shop.table.li.first"
              defaultMessage="Бесплатный хостинг"
            />
          </MobileLi>
          <MobileLi>
            <FormattedMessage
              id="shop.table.li.second"
              defaultMessage="Мобильная версия"
            />
          </MobileLi>
          <MobileLi>
            <FormattedMessage
              id="shop.table.li.third"
              defaultMessage="SEO возможности"
            />
          </MobileLi>
          {/* <MobileLi>
            <FormattedMessage
              id="shop.table.li.fourth"
              defaultMessage="Корпоративная почта"
            />
          </MobileLi> */}
          <MobileLi>
            <FormattedMessage
              id="shop.table.li.fifth"
              defaultMessage="Интеграция с E-mail сервисом"
            />
          </MobileLi>
          <MobileLi>
            <FormattedMessage
              id="shop.table.li.sixth"
              defaultMessage="1С синхронизация"
            />
          </MobileLi>
          {/* <MobileLi>
            <FormattedMessage
              id="shop.table.li.seventh"
              defaultMessage="Корпоративная почта"
            />
          </MobileLi> */}
        </MobileUl>
        <MobileFooter>
          <Button
            onClick={() => window.clickButton('b24-web-form-popup-btn-16')}
            /* onMouseOver={() => window.initializeBitrix()}
            onTouchStart={() => window.initializeBitrix()} */
          >
            <FormattedMessage
              id="shop.table.choose.lite"
              defaultMessage="Выбрать Lite"
            />
          </Button>
        </MobileFooter>
      </MobileCard>
      <MobileCard>
        <MobileHeader>
          <MobilePlan>Standart</MobilePlan>
          <MobilePrice>
            <FormattedMessage
              id="shop.table.price.first.two"
              defaultMessage="от 1599 лей/месяц"
            />
          </MobilePrice>
        </MobileHeader>
        <MobileUl>
          <MobileLi>
            <FormattedMessage
              id="shop.table.li.first.two"
              defaultMessage="Lite включено"
            />
          </MobileLi>
          <MobileLi>
            <FormattedMessage
              id="shop.table.li.second.two"
              defaultMessage="Мобильная версия"
            />
          </MobileLi>
          <MobileLi>
            <FormattedMessage
              id="shop.table.li.third.two"
              defaultMessage="Модуль: просмотренных товаров"
            />
          </MobileLi>
          <MobileLi>
            <FormattedMessage
              id="shop.table.li.fourth.two"
              defaultMessage="Модуль: Личный кабинет"
            />
          </MobileLi>
          <MobileLi>
            <FormattedMessage
              id="shop.table.li.fifth.two"
              defaultMessage="Подключение оплат VISA/Mastercard"
            />
          </MobileLi>
          <MobileLi>
            <FormattedMessage
              id="shop.table.li.sixth.two"
              defaultMessage="Создание FEED XML Facebook и Google"
            />
          </MobileLi>
          <MobileLi>
            <FormattedMessage
              id="shop.table.li.seventh.two"
              defaultMessage="Бесплатный SSL - Сертификат"
            />
          </MobileLi>
        </MobileUl>
        <MobileFooter>
          <Button
            className="active"
            onClick={() => window.clickButton('b24-web-form-popup-btn-12')}
          >
            <FormattedMessage
              id="shop.table.choose.lite.two"
              defaultMessage="Выбрать Standart"
            />
          </Button>
        </MobileFooter>
      </MobileCard>
    </React.Fragment>
  );
};

export default TableBlock;
